import PropTypes from 'prop-types';
import { formatDealCount } from '../../utils/formatDealCount';

/** "🔥 709 deals for "lamp" in Electronics" above the grid. */
const DealCountHeader = ({ pagination, searchTerm, category }) => (
  <div className="container">
    <div className="deal-count-header">
      <span className="deal-count-header__text">
        🔥 {formatDealCount(pagination)}
        {searchTerm && <span className="deal-count-header__detail"> for &quot;{searchTerm}&quot;</span>}
        {category && category.toLowerCase() !== 'all' && <span className="deal-count-header__detail"> in {category}</span>}
      </span>
    </div>
  </div>
);

DealCountHeader.propTypes = {
  pagination: PropTypes.object.isRequired,
  searchTerm: PropTypes.string,
  category: PropTypes.string,
};

export default DealCountHeader;
